export const optionsWidth = [
    {id: 100, name: '100'},
    {id: 200, name: '200'},
    {id: 400, name: '400'},
    {id: 600, name: '600'},
    {id: 800, name: '800'},
    {id: 1000, name: '1000'},
]
